<template>
  <div id="app">
    <div v-if="isAuthLoading" class="auth-loading-container">
      <img :src="appLoaderGif" alt="auth-loading-gif" class="auth-loading-gif" />
      <div class="auth-loading-text">Loading</div>
    </div>
    <div v-else>
      <router-view />
      <AuthModal />
      <div v-if="isAppLoading" class="app-loader-container">
        <img :src="appLoaderGif" alt="auth-loading-gif" class="app-loader-gif" />
        <!-- <div class="auth-loading-text">Loading</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";
import AuthModal from "./components/auth/AuthModal.vue";
import { useAuthStore } from "./stores/authStore";
import { useAppStore } from "./stores/appStore";
import AppLoaderGif from "@/assets/gifs/app-loader.svg";

export default {
  name: "App",
  components: {
    AuthModal,
  },
  data() {
    return {
      appLoaderGif: AppLoaderGif,
    };
  },
  setup() {
    const authStore = useAuthStore();
    const { isAuthLoading } = storeToRefs(authStore);

    const appStore = useAppStore();
    const { isAppLoading } = storeToRefs(appStore);

    return { isAuthLoading, isAppLoading };
  },
};
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */
.auth-loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.auth-loading-text {
  color: #666;
  font-size: 1.5rem;
}

.auth-loading-gif {
  width: 100px;
  height: 100px;
}

.app-loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
}

.app-loader-gif {
  width: 100px;
  height: 100px;
}
</style>
